import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Card,
  CardContent,
  CardHeader,
  Link,
  Icon,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import ArrowForward from "@material-ui/icons/ArrowForward";
import ContainerCard from "../ContainerCard";

const useStyles = makeStyles((theme) => ({
  root: {
    // backgroundColor: "red",

    [theme.breakpoints.down("md")]: {
      backgroundColor: "white",
    },
  },
}));

const AboutUs = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ContainerCard
        title={props.title}
        link={props?.link}
        linkTitle={props?.linkTitle}
      >
        <List className={classes.CardContent} dense disablePadding>
          {props.data?.map((data, index) => {
            return (
              <ListItem button dense key={index}>
                <ListItemIcon>
                  <ArrowForward />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography variant="body1" className={classes.description}>
                      {data?.title || "description"}
                    </Typography>
                  }
                />
              </ListItem>
            );
          })}
          {/* <Typography variant="body1" className={classes.description}>
            {props?.description || "description"}
          </Typography> */}
        </List>
      </ContainerCard>
    </div>
  );
};
export default AboutUs;
